import { render, staticRenderFns } from "./noticedetail.vue?vue&type=template&id=acbcb5f0&scoped=true&"
import script from "./noticedetail.vue?vue&type=script&lang=js&"
export * from "./noticedetail.vue?vue&type=script&lang=js&"
import style0 from "./noticedetail.vue?vue&type=style&index=0&id=acbcb5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbcb5f0",
  null
  
)

export default component.exports